// Formatting a timestamp in the client specific time zone
// The returned date will always be in the format '5 Dec 2020, 18:00'
import Intl from 'intl'
import 'intl/locale-data/jsonp/en-GB'

const formatDateInLocalTimezone = (timestamp, showTime = true) => {
  const format = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }

  if (showTime) {
    format.hour = '2-digit'
    format.minute = '2-digit'
  }

  return (
    new Intl.DateTimeFormat('en-GB', format).format(timestamp * 1000)
  )
}

export default formatDateInLocalTimezone
